import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './case-review.scss';

interface CaseDetails {
  id: string;
  specialtyName: string;
  topicName: string;
  ipsScore: number | null;
  dataGatheringScore: number | null;
  diagnosisMgtScore: number | null;
  areasForImprovement: string;
  timestamp: string;
}

export function CaseReview() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [caseDetails, setCaseDetails] = React.useState<CaseDetails | null>(null);

  React.useEffect(() => {
    const localHistory = localStorage.getItem('sessionSummaries');
    if (localHistory) {
      try {
        const parsedLocalHistory: CaseDetails[] = JSON.parse(localHistory);
        const foundCase = parsedLocalHistory.find((item) => item.id === id);
        setCaseDetails(foundCase || null);
      } catch (error) {
        console.error('Error parsing session summaries:', error);
      }
    }
  }, [id]);

  if (!caseDetails) {
    return (
      <div className="case-review-container">
        <h1>Case not found</h1>
        <button onClick={() => navigate('/history')}>Back to History</button>
      </div>
    );
  }

  const totalScore = (
    (caseDetails.ipsScore || 0) + 
    (caseDetails.dataGatheringScore || 0) + 
    (caseDetails.diagnosisMgtScore || 0)
  );

  return (
    <div className="case-review-container">
      <button className="back-button" onClick={() => navigate('/history')}>← Back to History</button>
      <h1>Case Review</h1>
      <div className="case-details">
        <h2>{caseDetails.specialtyName}</h2>
        <p className="topic">Topic: {caseDetails.topicName}</p>
        
        <div className="scores">
          <h3>Scores:</h3>
          <p>IPS: {caseDetails.ipsScore} / 4</p>
          <p>Data Gathering: {caseDetails.dataGatheringScore} / 4</p>
          <p>Diagnosis & Management: {caseDetails.diagnosisMgtScore} / 4</p>
          <p className="total-score">Total Score: {totalScore} / 12</p>
        </div>

        <div className="feedback">
          <h3>Areas for Improvement:</h3>
          <p>{caseDetails.areasForImprovement}</p>
        </div>

        <p className="date">Date: {new Date(caseDetails.timestamp).toLocaleDateString()}</p>
      </div>
    </div>
  );
} 